import { EntityName, Page } from '@/components';
import { Flex, Heading, NetworkIcon } from '@blockanalitica/ui';
import HistoricChart from './HistoricChart';
import KPIs from './KPIs';

export default function SolanaPage() {
  return (
    <Page
      title={
        <EntityName symbol1={<NetworkIcon name="solana" size="5" />}>
          <Heading size="1">
            <Flex gap="xs">Solana</Flex>
          </Heading>
        </EntityName>
      }>
      <KPIs />

      <HistoricChart symbol="USDS" />
    </Page>
  );
}
